import { render, staticRenderFns } from "./SpeechRecorder.vue?vue&type=template&id=a2328050"
import script from "./SpeechRecorder.vue?vue&type=script&lang=js"
export * from "./SpeechRecorder.vue?vue&type=script&lang=js"
import style0 from "./SpeechRecorder.vue?vue&type=style&index=0&id=a2328050&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports